import { useState, useEffect } from "react";

const ConfirmDialog = () => {
  const [contentState, setContentState] = useState("");
  const [titleState, setTitleState] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [onOkDialog, setOkDialog] = useState(null);
  const [onCancelDialog, setCancelDialog] = useState(null);
  const [okBtnState, setOkBtnState] = useState("");
  const [cancelBtnState, setCancelBtnState] = useState("");
  const [hideCancelBtn, setHideCancelBtn] = useState(false);
  const [isReverse, setReverse] = useState(false);

  const handleShowDialog = (title = "", content = "", onOk = null, onCancel = null, okBtn = "OK", hideCancelBtn = false, cancelBtn = "Đóng", isReverse = false) => {
    setContentState(content);
    setTitleState(title);
    setOkDialog(() => onOk);
    setCancelDialog(() => onCancel);
    setOpenDialog(true);
    setOkBtnState(okBtn);
    setCancelBtnState(cancelBtn);
    setHideCancelBtn(hideCancelBtn)
    setReverse(isReverse)
  }
  const handleCloseDialog = () => {
    setOpenDialog(false);
    onCancelDialog?.();
    setContentState("");
    setTitleState("");
    setOkDialog(null);
    setCancelBtnState(null);
    setCancelDialog(null);
    setOkBtnState("");
  }
  return {
    contentDialog: contentState, titleDialog: titleState, okBtn: okBtnState, hideCancelBtn,
    onOkDialog, openDialog, handleShowDialog, handleCloseDialog, cancelBtn: cancelBtnState, isReverse: isReverse
  };
};

export default ConfirmDialog;